// The share glyph: the Scoreboard's manager cards, the Lineup tab's week
// header and the League tab's standings. Opens the system share sheet with
// text built by the caller (utils/lineupShare.js, utils/standingsShare.js).
//
// getText is called on tap rather than passed as a string, so the text is
// built from whatever the page holds at that moment (scores move while a game
// is live). It may be async, but Safari only opens the sheet inside the tap
// itself, so anything it needs should already be in hand.
import React, { useEffect, useRef, useState } from "react";
import { Share, Check } from "lucide-react";
import { shareText } from "../capacitor/share";

const NOTE_MS = 2500;

function ShareButton({ getText, label = "Share", size = 20 }) {
  // "copied" or "failed". A shared or cancelled sheet needs no comment: the
  // sheet itself was the feedback.
  const [note, setNote] = useState(null);
  const [busy, setBusy] = useState(false);
  const timer = useRef(null);

  useEffect(() => () => clearTimeout(timer.current), []);

  const onClick = async (e) => {
    e.stopPropagation();
    if (busy) return;
    setBusy(true);
    let result = "failed";
    try {
      result = await shareText(await getText(), { title: "Lineup CFB" });
    } catch (err) {
      console.error("Share failed:", err);
    }
    setBusy(false);
    if (result === "copied" || result === "failed") {
      setNote(result);
      clearTimeout(timer.current);
      timer.current = setTimeout(() => setNote(null), NOTE_MS);
    }
  };

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      style={{
        position: "relative", display: "flex", alignItems: "center", justifyContent: "center",
        width: 44, height: 44, flexShrink: 0, border: "none", background: "none", padding: 0,
        cursor: "pointer", color: "var(--color-brand)", WebkitTapHighlightColor: "transparent",
      }}
    >
      {note === "copied" ? <Check size={size} strokeWidth={2} /> : <Share size={size} strokeWidth={1.8} />}
      {note && (
        <span
          role="status"
          style={{
            position: "absolute", top: "100%", right: 0, marginTop: -4, zIndex: 5, whiteSpace: "nowrap",
            fontSize: 11, fontWeight: 600, padding: "4px 8px", borderRadius: 6,
            backgroundColor: "var(--color-cta)", color: "var(--color-cta-text)",
          }}
        >
          {note === "copied" ? "Copied. Paste it anywhere." : "Could not share. Try again."}
        </span>
      )}
    </button>
  );
}

export default ShareButton;
